<template>
   <vue-final-modal
      v-model="searchAffilModal" 
      classes="modal-container"
      content-class="v310-modal-content"
      drag-selector=".search-affil-area"
      :drag="true"
      @click-outside="$emit('cancel')"
      @opened="itSearch.focus()"
      >
      <!-- 
      -->
      <div class="search-affil-area">
      <button 
            id="dlast"
            type="button"
            class="modal__close btn btn-sm" 
            :tabindex="tabindex + 7"
            @click="$emit('cancel')"
            >
         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg tx-cl-white" viewBox="0 0 16 16">
            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
         </svg>
      </button>
      <span class="modal__title tx-cl-white">Buscar Afiliados</span>
      </div>
      <div :tabindex="tabindex + 7" onfocus="document.getElementById('dfirst').focus()"></div>
      <!-- 
      -->
      <div :tabindex="tabindex + 1" onfocus="document.getElementById('dlast').focus()"></div>
      <div class="row justify-content-evenly mx-0">
         <div v-for="(option, index) in options" :key="index"
            class="form-check col-auto"
            >
            <input class="form-check-input px-2" type="radio" name="flexRadioDefault"
               :checked="index == 0"
               @click=" selectedsearchOption = option.code "
               id="dfirst"
               :tabindex="tabindex + 2"
               >
            <label class="form-check-label tx-cl-white" for="option.code">
               {{option.label}}
            </label>
         </div>
      </div>

      <div class="search-affil border-top border-bottom py-1 my-1">
         <table class="table table-sm table-secondary table-striped table-borderless m-0">
            <thead class="table-dark">
               <tr class="bg-thead">
                  <td>CUIL</td>
                  <td class="ws-nowrap">Apellido y Nombre</td>
                  <td colspan="2">Documento</td>
               </tr>
            </thead>
            <tbody>
               <tr v-for="(item, index) in dataFound" :key="index" 
                     class="border-0" 
                     :class=" item.active ? '' : 'table-danger'"
                     @click="$emit( 'cuil', item.id.toString())"
                     >
                  <td>{{item.id}}</td>
                  <td class="ws-nowrap">{{item.name}}</td>
                  <td>{{item.documentType}}</td>
                  <td>{{item.documentNumber}}</td>
               </tr>
            </tbody>
         </table>
      </div>
      <!--
      -->
      <div class="row m-0">
      <div class="d-flex justify-content-between p-0">
         <div class="col-7">
            <div class="input-group input-group-sm">
               <input ref="itSearch"
                     type="text" class="form-control"
                     v-model="inputSearch"  v-on:keyup.enter="searchAffiliate(true)"
                     aria-describedby="inputGroup-sizing-sm"
                     id="dfirstvv"
                     :tabindex="tabindex + 3"
               >
               <button 
                  type="submit" 
                  class="btn btn-sm btn-secondary" 
                  v-on:click="searchAffiliate(true)" 
                  :tabindex="tabindex + 4"
                  >
                     <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                     </svg>
               </button>
            </div>
         </div>
         <div class="col-5">
            <div class="input-group input-group-sm d-flex justify-content-end">
                  <button 
                     type="button" 
                     class="btn btn-sm btn-light border-0 border-end" 
                     v-on:click="addItems()" 
                     :tabindex="tabindex + 5"
                     >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg pb-1" viewBox="0 0 16 16">
                           <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                        </svg>
                  </button>
                  <span class="input-group-text bg-light border-light" >{{itemsShow}}/{{totalItems}}</span>
                  <button 
                     type="button" 
                     class="btn btn-sm btn-light border-0 border-start" 
                     v-on:click="reset()" 
                     :tabindex="tabindex + 6"
                     >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eraser" viewBox="0 0 16 16">
                           <path d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828l6.879-6.879zm2.121.707a1 1 0 0 0-1.414 0L4.16 7.547l5.293 5.293 4.633-4.633a1 1 0 0 0 0-1.414l-3.879-3.879zM8.746 13.547 3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293l.16-.16z"/>
                        </svg>
                  </button>
            </div>
         </div>
      </div>
      </div>
   </vue-final-modal>
</template>

<script>

import { VueFinalModal } from 'vue-final-modal'
import { ref } from 'vue'

import AnalyService from "../../analytics.service";

export default {

   components: {
      VueFinalModal
   },
   props: {
      tabindex: { 
         type: Number,
         default: 100
      }
   },
   emits: [ 'cancel' ,  'cuil' ],

   setup() {

      const dataFound = ref([])
      const inputSearch = ref('')
      const itemsShow = ref(0)
      const itSearch = ref(null)
      const options = ref([
         {"code":"TXT","label":"Nombre"},
         {"code":"NUM","label":"Nro. Documento"},
         {"code":"ID","label":"CUIL"}
         ])
      const searchAffilModal = ref(true)
      const selectedsearchOption = ref('TXT')
      const totalItems = ref(0)

      function addItems() {
         if (itemsShow.value < totalItems.value) {
            searchAffiliate(false)
         }
      }

      function reset() {
         dataFound.value = []
         inputSearch.value = ''
         itemsShow.value = 0
         totalItems.value = 0
         itSearch.value.focus()
      }

      function searchAffiliate( start ) {
         if (start) {
            dataFound.value = []
            itemsShow.value = 0
         }
         
         AnalyService.findAffiliateAllData(
            10,                  // itemsByPage, 
            itemsShow.value,     //  start, 
            inputSearch.value,    // searchText
            selectedsearchOption.value // searchOption
            )
         .then(response => {
            dataFound.value.push(...response.data.affiliateList)
            totalItems.value = response.data.totalItems
            itemsShow.value = dataFound.value.length
         })
         .catch(error => {
            console.log(error);
         });
      }

      return {
         addItems,
         dataFound,
         inputSearch, itemsShow, itSearch,
         options,
         reset,
         searchAffiliate, searchAffilModal, selectedsearchOption,
         totalItems
      }
   },
}
</script>

<style scoped>
/*
  margin: 0 1rem;
*/
.search-affil {
   background-color: #9E9E9E ;
   /*
   margin-top: 10px ;
   max-width: 500px;
   max-height: calc(100vh - 28px);
   */
   max-width: 500px;
   height: 23rem;
   overflow-y: auto;
   color: white;
}
.modal__title {
  margin: 0 2rem 0 0.20rem;
  font-size: 1.25rem;
  font-weight: 450;
}
.modal__close {
  position: absolute;
  top: 0.05rem;
  right: 0.10rem;
}
.tx-cl-white {
   color: white;
}
.ws-nowrap {
   white-space: nowrap;
}
</style>
